/* Theme-wide JS — reveal animations, header scroll state, marquee offset.
   Runs once on every page. */

const io = new IntersectionObserver(es => {
  es.forEach(e => { if (e.isIntersecting) e.target.classList.add('is-visible'); });
}, { rootMargin: '0px 0px -10% 0px' });

document.querySelectorAll('.ad-reveal').forEach(el => io.observe(el));

/* If marquee + header are both present, push header down so they don't collide. */
const marquee = document.querySelector('.ad-marquee');
const header  = document.querySelector('.ad-header');
if (marquee && header) {
  const apply = () => { header.style.top = marquee.offsetHeight + 'px'; };
  apply();
  window.addEventListener('resize', apply);
}
